import { useMemberPortalAccess } from '@/hooks/useMemberPortalAccess';
import { MemberPortalHomePage } from '@/pages/member-portal/MemberPortalHomePage';
import { Navigate, createFileRoute } from '@tanstack/react-router';

function MemberPortalIndexRoute() {
	const { canAuthor, isMember } = useMemberPortalAccess();
	if (canAuthor && !isMember) {
		return <Navigate to="/member-portal/overview" replace />;
	}
	return <MemberPortalHomePage />;
}

export const Route = createFileRoute('/_authenticated/_app/member-portal/')({
	component: MemberPortalIndexRoute,
});
